//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LaySelect from '@/components/LaySelect' 
export default {
    props:{
        searchData:Object
    },
    data(){
        return{
            states:[{
                label:'已作废',
                value:'-1'
            },{
                label:'未使用',
                value:'1'
            },{
                label:'已使用',
                value:'2'
            },{
                label:'已退回',
                value:'4'
            }]
        }
    },
    components:{
        LaySelect
    },
    methods:{
        reset(){
            for(let key in this.searchData){
                this.searchData[key]=''
            }
            this.$parent.pageConfig.current = 1;
            this.$emit('search')
        },
        add(){
            this.$emit('add')
        },
        search(){
            this.$parent.pageConfig.current = 1;
            this.$emit('search')
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/create/Search.vue